import React, {Component} from 'react'
import { CardBody, Collapse } from 'reactstrap';
import propTypes from 'prop-types';

import SearchForm from './SearchForm';
import SortForm from './SortForm';

export default class Filters extends Component {
  render(){
    return(
      <Collapse isOpen={this.props.isOpen}>
        <CardBody className="filter-container__card-body">
          <SearchForm
            keyword = {this.props.keyword}
            categoryOptions={this.props.categoryOptions}
            category_id={this.props.category_id}
            platform={this.props.platform}
            type={this.props.type}
            onInputChange = {this.props.onHandleChange}
            onSubmit = {this.props.onHandleSearch}
          />
          <hr/>
          <SortForm
            per_page={this.props.per_page}
            sort_by={this.props.sort_by}
            onInputChange={this.props.onHandleChangeAndSubmit}
          />
        </CardBody>
      </Collapse>
    )
  }
}

Filters.propTypes= {
  categoryOptions: propTypes.array,
  type: propTypes.string,
  // category_id: propTypes.number,
  platform: propTypes.string,
  keyword: propTypes.string,
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sort_by: propTypes.string,
  isOpen: propTypes.bool.isRequired,
  onHandleChangeAndSubmit:propTypes.func,
  onHandleChange: propTypes.func,
  onHandleSearch: propTypes.func
}

Filters.defaultProps= {
  categoryOptions: [],
  category_id: '',
  platform: '',
  type: '',
  keyword: '',
  per_page: 15,
  sort_by: ''
}